import 'axios';
import { getRequest, postRequest, putRequest, deleteRequest } from './axiosHelpers.js';

// "enum like" object to represent the available HttpMethods
const HttpMethods = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE'
};

// 'enum like' type for the HttpMethods

({
  [HttpMethods.GET]: getRequest,
  [HttpMethods.POST]: postRequest,
  [HttpMethods.PUT]: putRequest,
  [HttpMethods.DELETE]: deleteRequest
});

export { HttpMethods };
//# sourceMappingURL=requestHandler.js.map
